import { v1ApiClient } from '@/services';
import type { PathParams, ResponseBody } from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type SignalPath = '/v1/workspaces/{workspace_id}/signals/{signal_id}';

type DeleteSignalParams = Partial<Pick<PathParams<SignalPath, 'delete'>, 'workspace_id'>> &
  Pick<PathParams<SignalPath, 'delete'>, 'signal_id'>;
type DeleteSignalResponse = ResponseBody<SignalPath, 'delete'>;
type DeleteSignalFunction = (
  params: DeleteSignalParams,
) => Promise<DeleteSignalResponse>;

/**
 * Signal 삭제
 */
export const deleteSignal: DeleteSignalFunction = ({
  workspace_id,
  signal_id,
}) => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .delete(`/workspaces/${wa}/signals/${signal_id}`)
    .then((res) => res.data);
};
